import React, { useEffect, useState } from 'react';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { useForm } from 'react-hook-form';
import { PrimaryButton } from '../../shared/components/common/primary_button';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../data/storeConfig';
import { saveAddressInfo } from '../../data/reducers/cart.reducer';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/reducers';
import { constants } from '../../config';

export type AddressInfo = {
  fullName: string;
  Address1: string;
  OrderType: string;
  Address2?: string;
  Landmark?: string;
  City: string;
  Province: string;
  Locality: string;
  contactNumber: string;
  alternateContactNumber: string;
  notes: string;
};

const AddressSelectPage = () => {
  const { storeSlug } = useParams<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { addressInfo } = useSelector((state: RootState) => state.cartReducer);
  const [isDeliverySelected, setIsDeliverySelected] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isAltPhoneValid, setIsAltPhoneValid] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AddressInfo>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: 'firstError',
    shouldFocusError: true,
    shouldUnregister: false,
    delayError: undefined,
  });
  const { storeInfo } = useSelector((rootState: RootState) => rootState.storeReducer);
  const {} = useSelector((rootState: RootState) => rootState.authReducer);

  const onSubmit = (data: AddressInfo, e: any) => {
    dispatch(saveAddressInfo(data));
    navigate(`/${storeSlug}/buy/review`);
  };
  const onError = (errors: any, e: any) => {
    console.log(errors);
    errors.forEarch((err: any) => toast.error(err));
  };

  // useEffect(() => {
  //   if (storeInfo) {
  //     if (!storeInfo.deliveryAvailable) {
  //       navigate(`/${storeSlug}/buy/review`);
  //     }
  //   }
  // }, [storeInfo, storeInfo?.deliveryAvailable]);

  return (
    <NavigationShell title="Delivery">
      <form className="h-full -mt-14" onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="flex-row px-6 pt-6 md:px-6 md:pt-6 pb-40">
          {/* Full name */}
          <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
            <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
              Name
            </div>
            <input
              type="text"
              className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
              id="fullname"
              defaultValue={
                addressInfo.fullName ??
                (localStorage.getItem(constants.USER_NAME + storeSlug) !== 'undefined'
                  ? localStorage.getItem(constants.USER_NAME + storeSlug)
                  : '')
              }
              {...register('fullName', {
                required: true,
              })}
            />
            {errors.fullName?.message}
            {errors.fullName && <p className="text-sm text-red-600 text-left pt-1.5">Full name is required</p>}
          </div>

          {/* Order type */}

          <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
            <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
              Order type
            </div>
            <div className="flex flex-row justify-start">
              {storeInfo?.pickupAvailable ? (
                <div className="mr-5">
                  <input
                    type="radio"
                    required={true}
                    value="PICKUP"
                    defaultChecked={true}
                    className="mr-2"
                    id="orderType_1"
                    {...register('OrderType', {
                      required: true,
                    })}
                    onClick={() => setIsDeliverySelected(false)}
                  />
                  <label htmlFor="orderType_1">Pick-up</label>
                </div>
              ) : (
                <></>
              )}
              {storeInfo?.deliveryAvailable ? (
                <div className="mr-5">
                  <input
                    type="radio"
                    required={true}
                    className="mr-2"
                    id="orderType_2"
                    {...register('OrderType', {
                      required: true,
                    })}
                    value="DELIVERY"
                    onClick={() => setIsDeliverySelected(true)}
                  />
                  <label htmlFor="orderType_2">Delivery</label>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          {storeInfo?.deliveryAvailable && isDeliverySelected ? (
            <div>
              {/* Address 1 */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Address line 1
                </div>
                <input
                  type="text"
                  defaultValue={
                    addressInfo.Address1 ??
                    (localStorage.getItem(constants.USER_ADDR_L1 + storeSlug) !== 'undefined'
                      ? localStorage.getItem(constants.USER_ADDR_L1 + storeSlug)
                      : '')
                  }
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="addr_1"
                  {...register('Address1', {
                    required: true,
                  })}
                />
                {errors.Address1 && <p className="text-sm text-red-600 text-left pt-1.5">Address line 1 is required</p>}
              </div>
              {/* Address 2 */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Address line 2
                </div>
                <input
                  type="text"
                  defaultValue={addressInfo.Address2}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="addr_2"
                  {...register('Address2', {
                    required: false,
                  })}
                />
              </div>
              {/* Landmark */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Landmark
                </div>
                <input
                  type="text"
                  defaultValue={addressInfo.Landmark}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="landmark"
                  {...register('Landmark', {
                    required: false,
                  })}
                />
              </div>
              {/* Locality */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Barangay
                </div>
                <input
                  type="text"
                  defaultValue={addressInfo.Locality}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="locality"
                  {...register('Locality', {
                    required: true,
                  })}
                />
                {errors.Locality && <p className="text-sm text-red-600 text-left pt-1.5">Locality is required</p>}
              </div>
              {/* City */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  City
                </div>
                <input
                  type="text"
                  defaultValue={addressInfo.City}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="city"
                  {...register('City', {
                    required: true,
                  })}
                />
                {errors.City && <p className="text-sm text-red-600 text-left pt-1.5">City is required</p>}
              </div>
              {/* Province */}
              {/* <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
            <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
              Province
            </div>
            <input
              type="text"
              required={true}
              defaultValue={addressInfo.Province}
              className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
              id="province"
              {...register('Province', {
                required: true,
              })}
            />
          </div> */}
              {/* Phone number */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Phone number
                </div>
                <input
                  type="tel"
                  required={true}
                  // Phone number sliced as per PH number country code "63"
                  defaultValue={
                    addressInfo.contactNumber ??
                    (localStorage.getItem(constants.USER_PHONE_KEY + storeSlug) !== 'undefined'
                      ? localStorage.getItem(constants.USER_PHONE_KEY + storeSlug)?.slice(2)
                      : '')
                  }
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="phoneNumber"
                  pattern="[0-9]{10}"
                  max={10}
                  onInvalidCapture={() => setIsPhoneValid(false)}
                  {...register('contactNumber', {
                    required: true,
                    onChange: () => {
                      setIsPhoneValid(true);
                    },
                  })}
                />
                {!isPhoneValid && (
                  <div className="text-theLighterDark text-xs mt-1 text-left">Enter a valid 10 digit phone number.</div>
                )}
                {errors.contactNumber && (
                  <p className="text-sm text-red-600 text-left pt-1.5">Contact number is required</p>
                )}
              </div>
              {/* Alternate phone number */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Alternate phone number
                </div>
                <input
                  type="tel"
                  pattern="[0-9]{10}"
                  required={false}
                  max={10}
                  defaultValue={addressInfo.alternateContactNumber}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="alternatePhoneNumber"
                  onInvalidCapture={() => setIsAltPhoneValid(false)}
                  {...register('alternateContactNumber', {
                    required: false,
                    onChange: () => {
                      setIsAltPhoneValid(true);
                    },
                  })}
                />
                {!isAltPhoneValid && (
                  <div className="text-theLighterDark text-xs mt-1 text-left">Enter a valid 10 digit phone number.</div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
          <div>
              {/* Notes */}
              <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
                <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                  Note
                </div>
                <textarea
                  rows={5}
                  defaultValue={addressInfo.notes}
                  className="appearance-none bg-neutral-100 w-full p-3 md:p-3 rounded-lg text-neutral-900 font-inter font-normal text-base focus:outline-none"
                  id="notes"
                  {...register('notes', {
                    required: false,
                  })}
                />
              </div>
            </div>

          {/* City Dropdown */}
          {/* <div className="flex-row md:flex-row bg-white pb-6 md:pb-6">
              <div className="w-full md:w-full pb-1.5 md:pb-1.5 text-left md:text-left font-inter font-medium text-black">
                City
              </div>
              <div className="inline-block relative w-full ">
                <select className="cursor-pointer  appearance-none w-full p-3 md:p-3 pr-8 md:pr-8 bg-neutral-100 rounded-lg focus:outline-none font-inter font-normal text-neutral-900 text-base">
                  <option>Option 1</option>
                  <option>Option 2</option>
                  <option>Option 3</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-neutral-900">
                  <svg className="fill-current h-5 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div> */}
        </div>

        {/* Checkout Button */}
        <div className="p-6 md:p-6 fixed bottom-0 w-full bg-white border-t z-40">
          <div className="md:w-2/4 mx-auto">
            <PrimaryButton
              text="Checkout"
              onclick={() => {
                console.log(`Checkout`);
              }}
            />
          </div>
        </div>
      </form>
    </NavigationShell>
  );
};

export default AddressSelectPage;
